var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ValidationMessage } from "@/components/ValidationMessage";
import { Container } from "@/components/common/Container";
import { PageTitle } from "@/components/common/PageTitle";
import { ServiceInfo, ServiceInfoItem } from "@/components/common/ServiceInfo";
import { Button } from "@/components/ui/Button";
import { Form, FormControl, FormDescription, FormField, FormItem, FormLabel, FormMessage, } from "@/components/ui/Form";
import { Input } from "@/components/ui/Input";
import { LoadingSpinner } from "@/components/ui/LoadingSpinner";
import { cn } from "@/lib/utils";
import GatewayService from "@/services/api/GatewayService";
import { completeWithZeros } from "@/utils/masks";
import { zodResolver } from "@hookform/resolvers/zod";
import { isAxiosError } from "axios";
import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { toast } from "sonner";
import { z } from "zod";
var Home = function () {
    var service = new GatewayService();
    var _a = useState(false), isLoading = _a[0], setIsLoading = _a[1];
    var _b = useState(), validatedCertificate = _b[0], setValidatedCertificate = _b[1];
    var formSchema = z.object({
        register: z
            .string()
            .min(9, "Número de registro inválido. O mínimo permitido são 9 números.")
            .max(11, "Número de registro inválido. O máximo permitido são 11 números."),
        validationCode: z
            .string()
            .length(14, "Código de validação inválido. Ele precisa ter 14 caracteres."),
    });
    var form = useForm({
        resolver: zodResolver(formSchema),
        defaultValues: {
            register: "",
            validationCode: "",
        },
    });
    function onSubmit(values) {
        return __awaiter(this, void 0, void 0, function () {
            var convertedValues, response_1, error_1, axiosError_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        setIsLoading(true);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        convertedValues = __assign(__assign({}, values), { register: completeWithZeros(values.register, 11) });
                        return [4 /*yield*/, service.validarNadaConsta(convertedValues)];
                    case 2:
                        response_1 = _a.sent();
                        setValidatedCertificate(function () { return ({
                            validated: true,
                            statusCode: response_1.statusCode,
                            message: "Certidão Valida",
                        }); });
                        return [3 /*break*/, 5];
                    case 3:
                        error_1 = _a.sent();
                        if (isAxiosError(error_1)) {
                            axiosError_1 = error_1;
                            setValidatedCertificate(function () {
                                var _a;
                                return ({
                                    validated: false,
                                    statusCode: (_a = axiosError_1.status) !== null && _a !== void 0 ? _a : 500,
                                    message: axiosError_1.message,
                                });
                            });
                            if (axiosError_1.status !== 422) {
                                toast.error("Ocorreu um erro ao validar a certidão. Tente novamente mais tarde.");
                            }
                        }
                        return [3 /*break*/, 5];
                    case 4:
                        setIsLoading(false);
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    }
    return (_jsxs(Container, { children: [_jsx(PageTitle, { title: "Validar Nada Consta" }), _jsxs(ServiceInfo, { children: [_jsx(ServiceInfoItem, { title: "Instru\u00E7\u00F5es para validar Certid\u00E3o de Nada Consta", content: [
                            "Preencha corretamente os dados abaixo seguindo rigorosamente o que está impresso na CNH e na Certidão. ",
                            'Confirme clicando em "Validar".',
                        ] }), _jsx(ServiceInfoItem, { title: "", listType: "none", content: [
                            "Obs.: Esta funcionalidade apenas consulta um Nada Consta já emitido.",
                        ] })] }), _jsx("section", __assign({ className: "w-full max-w-[856px] py-4 px-4" }, { children: _jsx(Form, __assign({}, form, { children: _jsxs("form", __assign({ onSubmit: form.handleSubmit(onSubmit), className: "w-full flex flex-col gap-4" }, { children: [_jsxs("div", __assign({ className: "flex flex-col gap-6 sm:flex-row" }, { children: [_jsx(FormField, { control: form.control, name: "register", render: function (_a) {
                                            var field = _a.field;
                                            return (_jsxs(FormItem, __assign({ className: "w-full pr-0 transition-all duration-500 ease-in-out md:pr-1" }, { children: [_jsx(FormLabel, { children: "Registro" }), _jsx(FormControl, { children: _jsx(Input, __assign({ placeholder: "000000000", maxLength: 11 }, field)) }), _jsx(FormDescription, { children: "O n\u00BA do Registro se encontra no verso da sua habilita\u00E7\u00E3o." }), _jsx(FormMessage, {})] })));
                                        } }), _jsx(FormField, { control: form.control, name: "validationCode", render: function (_a) {
                                            var field = _a.field;
                                            return (_jsxs(FormItem, __assign({ className: "w-full pr-0 transition-all duration-500 ease-in-out sm:w-1/2 md:pr-1 " }, { children: [_jsx(FormLabel, { children: "C\u00F3digo de Valida\u00E7\u00E3o" }), _jsx(FormControl, { children: _jsx(Input, __assign({ placeholder: "000000000", maxLength: 14 }, field)) }), _jsx(FormMessage, {})] })));
                                        } })] })), _jsx(ValidationMessage, { validated: validatedCertificate === null || validatedCertificate === void 0 ? void 0 : validatedCertificate.validated, statusCode: validatedCertificate === null || validatedCertificate === void 0 ? void 0 : validatedCertificate.statusCode, message: validatedCertificate === null || validatedCertificate === void 0 ? void 0 : validatedCertificate.message }), !validatedCertificate && (_jsx(Button, __assign({ disabled: isLoading, className: "mt-4 bg-etipi-blue hover:bg-etipi-blue hover:brightness-105 focus:bg-etipi-blue focus:brightness-90 sm:w-[256px] sm:self-end" }, { children: isLoading ? _jsx(LoadingSpinner, {}) : "Validar" }))), validatedCertificate && (_jsx(Button, __assign({ type: "button", onClick: function () {
                                    form.reset();
                                    setValidatedCertificate(undefined);
                                }, variant: "outline", disabled: isLoading, className: cn("mt-4", "border-etipi-blue text-etipi-blue hover:brightness-105 hover:text-etipi-blue focus:brightness-110 focus:text-etipi-blue", "sm:w-[256px] sm:self-end") }, { children: isLoading ? _jsx(LoadingSpinner, {}) : "Nova Validação" })))] })) })) }))] }));
};
export default Home;
